import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, ListItemIcon } from '@mui/material';
import { useSelector } from 'react-redux';


export default function MoreMenu({ options }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const maintheme = useSelector((state) => state.themeData.maintheme);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (option) => {
    setAnchorEl(null);
    if (option?.onClick)
      option?.onClick()
  };

  return (
    <React.Fragment>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>

        {/* <Tooltip title={props?.title}> */}
        <IconButton
          onClick={handleClick}
          size="small"
         
          aria-controls={open ? 'account-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >
          <MoreVertIcon sx={{
            color: maintheme?.primary,
            fontSize: "40px",
          }} />
        </IconButton>
        {/* </Tooltip> */}
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              left: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >

        {options.map((option, index) => (
          <MenuItem onClick={() => { handleClose(option) }} className="ActionIcons">
            <ListItemIcon sx={{
              display: 'flex',
              justifyContent: 'center',
              margin: '0px 7px 0 0'
            }}>
              {option?.icon}
            </ListItemIcon>
            {option?.name}
          </MenuItem>
          // <MenuItem key={option?.name+"_"+index} onClick={()=>{handleClose(option)}}  className="ActionIcons">
          //   {option?.name}
          // </MenuItem>
        ))}


      </Menu>
    </React.Fragment>
  );
}